import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const PowerdBy = ({ colored, withborder = true, customStyle = {} }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        borderTop: `${colored ? 0 : !withborder ? 0 : 1}px solid #FAFAFA`,
        width: "100%",
        height: 70,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: colored
          ? customStyle?.backgroundColor ?? "#FAFAFA"
          : customStyle?.backgroundColor ?? "#FFFFFF",
      }}
    >
      <Box>
        <noscript>
          <a href={window.location.href} target="_blank">
            Please fill out the form
          </a>
        </noscript>
        <div className="treffas-webform-container">
          <Typography
            variant={"caption"}
            sx={{
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "31px",
              color: "#838383",
            }}
          >
            {t("powered_by")}
          </Typography>

          <a
            className="treffas-webform-inner"
            rel="nofollow"
            href="https://treffas.com"
            target="_blank"
            style={{ color: customStyle?.textColor ?? "var(--color-black)" }}
          >
            Treffas
          </a>
        </div>
      </Box>
    </Box>
  );
};

export default PowerdBy;
